var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',{attrs:{"role":"region","surveys":""}},[_c('div',{staticClass:"level pl-5 pr-5"},[_c('div',{staticClass:"pt-5 level-left level-item title"},[_vm._v(_vm._s(_vm.$t('surveys.detailsTitle')))])]),_c('LinksMenu',{style:({
      paddingLeft: '20px'
    }),attrs:{"aria-label":"account settings tabs","tabs":_vm.tabs,"prefix":"communityCenter.","styles":{
      ul: {
        width: '155px'
      }
    }}},[_c('section',{style:({ overflowX: 'auto', flexGrow: 2, marginTop: '-30px' })},[_c('SlideTransition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[_c('router-view')],1)],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }